// 春节日期维护
export const chineseNewYear = {
    2017: { m: 1, d: 27 },
    2018: { m: 2, d: 15 },
    2019: { m: 2, d: 4 },
    2020: { m: 1, d: 24 },
    2021: { m: 2, d: 11 },
    2022: { m: 2, d: 1 },
    2023: { m: 1, d: 21 },
    2024: { m: 2, d: 9 },
    2025: { m: 1, d: 28 },
    2026: { m: 2, d: 16 },
    2027: { m: 2, d: 5 },
};

// 收入区间
export const incomeRange = {
    1: "一亿以上",
    2: "6500-1亿",
    3: "4000-6500万",
    4: "3000-4000万",
    5: "2000-3000万",
    6: "1000-2000万",
    7: "<1000万",
};



// WEBPACK FOOTER //
// ./src/method/data.js